module.exports = __webpack_public_path__ + "img/p4.f9535436.png";